<template>
    <div
        class="arrow-button"
        :class="direction"
        @click="swipeCard({ cardSize, direction })"
    >
        <div class="arrow" :class="direction"></div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'ArrowButton',
    props: {
        cardSize: {
            type: String,
            required: true,
        },
        direction: {
            type: String,
            required: true,
        },
    },
    methods: {
        ...mapActions(['swipeCard']),
    },
}
</script>

<style lang="scss" scoped>
.arrow-button {
    height: 100%;
    width: 2.5%;
    display: flex;
    align-items: center;
    cursor: pointer;
    &.left {
        justify-content: flex-end;
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.2) 0%,
            rgba(255, 255, 255, 0.6) 30%,
            rgba(255, 255, 255, 0.8) 100%
        );
        border-radius: 0px 20px 20px 0px;
        box-shadow: 4px 3px 5px 1px rgba(136, 136, 136, 0.1);
    }
    &.right {
        justify-content: flex-start;
        background-image: linear-gradient(
            -90deg,
            rgba(255, 255, 255, 0.2) 0%,
            rgba(255, 255, 255, 0.6) 30%,
            rgba(255, 255, 255, 0.8) 100%
        );
        border-radius: 20px 0px 0px 20px;
        box-shadow: 1px 3px 5px 1px rgba(136, 136, 136, 0.1);
    }
    .arrow {
        height: 1.5vw;
        width: 1.5vw;
        border-style: solid;
        &.left {
            rotate: -45deg;
            border-width: 0.2vw 0 0 0.2vw;
            border-image: linear-gradient(
                    to bottom right,
                    rgba(136, 136, 136, 0.4) 0%,
                    rgba(136, 136, 136, 0.6) 100%
                )
                1;
        }
        &.right {
            rotate: 45deg;
            border-width: 0.2vw 0.2vw 0 0;
            border-image: linear-gradient(
                    to bottom left,
                    rgba(136, 136, 136, 0.4) 0%,
                    rgba(136, 136, 136, 0.6) 100%
                )
                1;
        }
    }
}
</style>
